import React from "react";
const WhatsAppButton = () => {
  return (
    <div id="whatsapp-float">
      <a
        href="https://wa.me/917028990059?text=Hello%2C%20I%20am%20interested%20in%20your%20services.%20Can%20you%20please%20provide%20more%20details%3F"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img 
          src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
          alt="Chat on WhatsApp"
          width="45"
        />
      </a>
      <style>
        {`
          #whatsapp-float {

            position: fixed;
            bottom: 20px;
            right: 25px;
            z-index: 1000;
          }
        `}
      </style>
    </div>
  );
};
export default WhatsAppButton;
